<template>
  <div>
    <div class="d-flex mb-4">
      <div class="flex-grow-1"></div>
      <create-goverment-rota-order
        :hospitals="hospitals"
        v-if="isCreate"
        :item="{}"
        :history="history"
        :organType="organType"
        @fetch="fetch()"
      ></create-goverment-rota-order>
    </div>
    <table-view
      :isSearch="false"
      :items="list"
      :isBusy="loading"
      :fields="headers"
    >
      <template v-slot:action="{ item }">
        <div class="d-flex">
          <create-goverment-rota-order
            :hospitals="history"
            v-if="isCreate"
            :history="list"
            @onUpdate="onUpdate"
            :item="item"
            :organType="organType"
            @fetch="fetch()"
          ></create-goverment-rota-order>
          <delete-button
            v-if="isDeletable"
            @click="removeHospital(item)"
          ></delete-button>
        </div>
      </template>
      <div class="d-flex mt-3">
        <div class="flex-grow-1"></div>
        <b-button
          v-if="list.length && isCreate"
          variant="success"
          @click="submit()"
          >Submit
        </b-button>
      </div>
    </table-view>
  </div>
</template>

<script>
import menuConstants from "../../../assets/constants/menu.constants";
import hospitalService from "../../../assets/services/hospital.service";
import DeleteButton from "../../buttons/DeleteButton.vue";
import TableView from "../../table/TableView.vue";
import CreateGovermentRotaOrder from "./CreateGovermentRotaOrder.vue";
export default {
  components: {
    TableView,
    DeleteButton,
    CreateGovermentRotaOrder,
  },
  props: {
    organType: {
      type: Number,
      default: 103,
    },
  },
  data() {
    return {
      hospitals: [],
      history: [],
      zone: null,
      list: [],
      loading: false,
    };
  },
  computed: {
    isCreate() {
      let hasAccess = this.hasCreateAccess(menuConstants.HOSPITAL_ROTA_ORDER);
      return hasAccess;
    },
    isDeletable() {
      let hasAccess = this.hasStatusAccess(
        menuConstants.HOSPITAL_ROTA_ORDER,
        4
      );
      return hasAccess;
    },
    headers() {
      let list = [];
      let headers = {
        sno: "S No",
        hospital_name: "Hospital Name",
        governmentinitial_rank: "Initial Rank",
        governmentcurrent_rank: "Current Rank",
        action: "Action",
      };
      Object.keys(headers).forEach((key) => {
        let label = headers[key];
        let doc = {
          label,
          sortable: true,
          key,
          tdClass: key == "action" ? "width-100" : "",
        };
        list.push(doc);
      });
      return list;
    },
  },
  watch: {
    zone() {
      this.getList();
    },
    organType() {
      this.fetch();
    },
  },
  methods: {
    async removeHospital({ rota_hospital_order_id }) {
      let vm = this;
      let i = 0;
      let list = [...vm.list].map((item) => {
        item.dml_indicator = "U";
        if (item.rota_hospital_order_id == rota_hospital_order_id) {
          item.status = 4;
        } else {
          item.status = 1;
          i++;
          item.governmentcurrent_rank = i;
        }
        return item;
      });
      try {
        vm.$loader.show();
        let { status, msg } = (
          await hospitalService.addGovermentRotaOrder({
            rota_hospital_orderlist: list,
          })
        ).data;
        vm.$loader.hide();
        if (!status) {
          vm.$alert.show(msg);
        } else {
          vm.dialog = false;
          vm.fetch();
        }
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    getList() {
      this.list = [...this.history].sort((a, b) => {
        return a.governmentcurrent_rank - b.governmentcurrent_rank;
      });
    },
    async onUpdate({ oldIndex, newIndex }) {
      let table = [...this.list];
      changePosition(table, oldIndex, newIndex);
      function changePosition(arr, fromIndex, toIndex) {
        var element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
      }
      this.list = table
        .map((item, i) => {
          item.governmentcurrent_rank = i + 1;
          return item;
        })
        .sort((a, b) => {
          return a.governmentcurrent_rank - b.governmentcurrent_rank;
        });
    },
    async submit() {
      const vm = this;
      try {
        vm.$loader.show();
        let list = [...this.list].map((item) => {
          item.dml_indicator = "U";
          return item;
        });
        let { status, msg } = (
          await hospitalService.addGovermentRotaOrder({
            rota_hospital_orderlist: list,
          })
        ).data;
        vm.$loader.hide();
        if (!status) {
          vm.$alert.show(msg);
        }
        vm.fetch();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
    async fetch() {
      const vm = this;
      try {
        vm.$loader.show();
        vm.hospitals = [];
        vm.history = [];
        let { list, status } = (await hospitalService.getLiverHospital(vm.organType)).data;
        list = (list || []).filter((i) => i.hospital_type == 1);
        let { data } = await hospitalService.getGovernmentRotaOrder(vm.organType);
        if (data.status) {
          vm.history = data.list.map((item) => {
            item.name = item.hospital_name;
            item.value = item.hospital_id;
            return item;
          });
        }
        if (status) {
          list = list.filter((item) => {
            return (
              vm.history.find((d) => {
                return d.hospital_id == item.hospital_id;
              }) == null
            );
          });
          vm.hospitals = list.map((item) => {
            item.name = item.hospital_name;
            item.value = item.hospital_id;
            return item;
          });
        }
        vm.getList();
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>

<style></style>
